import React from 'react';
import ReactPlayer from 'react-player/lazy';

const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

export const DescriptionRenderer = ({ text }: { text: string }) => {
  if (!text) {
    return null;
  }

  const parts = text.split(urlRegex);

  return (
    <>
      {parts.map((part, index) => {
        if (part && part.match(urlRegex) && ReactPlayer.canPlay(part)) {
          return (
            <div key={index} className="my-4 rounded-lg overflow-hidden shadow-lg" style={{ position: 'relative', paddingTop: '56.25%' }}>
              <ReactPlayer
                url={part}
                width="100%"
                height="100%"
                controls={true}
                style={{ position: 'absolute', top: 0, left: 0 }}
              />
            </div>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </>
  );
}; 